import { render, staticRenderFns } from "./TeamIconPhase2.9.vue?vue&type=template&id=a77bfa5a"
import script from "./TeamIconPhase2.9.vue?vue&type=script&lang=js"
export * from "./TeamIconPhase2.9.vue?vue&type=script&lang=js"
import style0 from "./TeamIconPhase2.9.vue?vue&type=style&index=0&id=a77bfa5a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports